import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4ba28f97&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba28f97",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ba28f97')) {
      api.createRecord('4ba28f97', component.options)
    } else {
      api.reload('4ba28f97', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4ba28f97&scoped=true&", function () {
      api.rerender('4ba28f97', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/userActivity/index.vue"
export default component.exports